import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Inject,
    Renderer2,
} from "@angular/core";

import { BlockTextDeprecated } from "@hermes/api-model-editorial";

import { CHAPTERS_PARAGRAPH } from "../../core";

@Component({
    selector: "h-block-text",
    templateUrl: "./block-text.component.html",
    styleUrls: ["./block-text.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockTextComponent implements AfterViewInit {
    constructor(
        @Inject(CHAPTERS_PARAGRAPH) public blockText: BlockTextDeprecated,
        private element: ElementRef,
        private renderer: Renderer2,
    ) {}

    public ngAfterViewInit(): void {
        const currentElement: HTMLElement = this.element.nativeElement;
        if (this.blockText.whiteBackground) {
            this.renderer.addClass(currentElement, "white-background");
        }
    }
}
